import { css, keyframes } from '@emotion/core'
import styled from '@emotion/styled'
import { MQ } from '@css/constants'

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

export const TabContentWrapper = styled('ul')(css`
  animation: ${fadeIn} 300ms ease;
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  padding-bottom: 40px;
  margin: 0 auto;
  max-width: 1000px;
  width: 90%;
  list-style: none;

  ${MQ.SMALL_SCREENS} {
    margin: 0;
    width: 100%;
  }
`)

export const GroupWrapper = styled('li')<{ size?: number }>(props => css`
  margin-right: 20px;
  min-width: ${props.size ? 'unset' : '264px'};
  width: ${props.size ? props.size + '%' : 'unset'};

  @media(max-width: 850px) {
    min-width: 200px;
    margin-right: 10px;
  }
`)
